import { Button, IconButton, TextField } from '@material-ui/core';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import React, { useReducer, useRef, useState, useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import CustomSelect from '../form-controls/custom-select/Custom-Select';
import CustomTextField from '../form-controls/custom-text-field/Custom-Text-Field';
import EditIcon from '@mui/icons-material/Edit';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { formDataValidate, handleValidation } from '../../utils/formUtils';
import MuiPhoneNumber from 'material-ui-phone-number';
import './ContactInformation.scss';
import { allCountriesPhoneData } from '../../utils/commonCountryPhoneCodes';
import CustomUpload from '../form-controls/custom-upload/Custom-Upload';
import { ASSET_TYPE_DOC } from '../../constants/PropertyConst';
import { allHotelsSelector } from '../../layouts/property/propertySlice';
import { useSelector } from 'react-redux';
import { PictureAsPdfOutlined } from '@material-ui/icons';
import { ASSET_AMENITIES, UPLOAD_PDF } from '../../constants/AmenityConst';
import { MAX_PDF_SIZE, PDF_fileType } from '../../utils/Constants';

const ContactInformation = (props) => {
  const {
    setContactInfoList,
    contactInfoList,
    informationTypes,
    infoFieldKey,
    infoValueKey,
    hotelId,
    isActivityModule = false,
  } = props;
  const [updateMode, setUpdateMode] = useState({
    isEdit: false,
    selectedIndex: -1,
  });
  const [infoTabError, setInfoTabError] = useState(false);
  const [selectedInfoType, setSelectedInfoType] = useState(null);
  const [isOnlyCode, setIsOnlyCode] = useState(false);
  const originalHotels = useSelector(allHotelsSelector);
  const groupId = originalHotels[0]?.groupId;
  const [contactFormData, setContactFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      infoType: {
        value: '',
        fieldName: 'Information Type',
        errors: {},
        validations: [],
      },
      titleField: {
        value: '',
        fieldName: 'Add Reviewer Title',
        errors: {},
        validations: ['required', 'duplicate'],
        maxLength: 36,
      },
      valueField: {
        value: '',
        fieldName: 'URL',
        errors: {},
        validations: ['required', 'validUrl', 'safeURL', 'duplicate'],
      },
      displayTitle: {
        value: '',
        fieldName: 'Display Title',
        errors: {},
        validations: [],
        maxLength: 36,
      },
      uploadPdf: {
        value: { url: '', type: '', name: '' },
        fieldName: 'Upload PDF',
        errors: {},
        validations: ['validIfUrl', 'safeURL'],
      },
    },
  );

  const selectRef = useRef(null);

  useEffect(() => {
    if (selectedInfoType?.valueType === 'Phone') {
      const isCode = allCountriesPhoneData?.some(
        (data) => data?.dialCode === contactFormData?.valueField?.value,
      );
      setIsOnlyCode(isCode);
    }
  }, [contactFormData?.valueField?.value, selectedInfoType?.valueType]);

  const valueValidations = {
    URL: ['required', 'validUrl', 'safeURL', 'duplicate'],
    Email: ['required', 'validEmail', 'duplicate'],
    Phone: ['required', 'duplicate'],
  };

  const onChangeInformationType = (e) => {
    const titleField = { ...contactFormData.titleField, value: '' };
    const valueField = { ...contactFormData.valueField, value: '' };
    const displayTitle = { ...contactFormData.displayTitle, value: '' };
    const uploadPdf = { ...contactFormData.uploadPdf, value: '' };
    updateFieldsForInforType(e.value, titleField, valueField, displayTitle, uploadPdf);
    setContactFormData({
      infoType: e,
      titleField,
      valueField,
      displayTitle,
      uploadPdf,
    });
  };

  const updateFieldsForInforType = (type, titleField, valueField, displayTitle) => {
    const selectedInfoType = informationTypes.find((infoType) => infoType?.value === type);
    if (type === PDF_fileType) {
      valueField.fieldName = UPLOAD_PDF;
      valueField.validations = ['required'];
      titleField.value = '';
      displayTitle.value = UPLOAD_PDF;
      setSelectedInfoType({ valueType: PDF_fileType });
    } else {
      titleField.fieldName = selectedInfoType?.title;
      valueField.fieldName = selectedInfoType?.valueType;
      valueField.validations = valueValidations[selectedInfoType?.valueType];
      setSelectedInfoType(selectedInfoType);
    }
  };

  const onChangeInformation = (e, fieldName, compareFieldName) => {
    const updatedField = {
      ...e,
    };
    if (fieldName === 'valueField') {
      updatedField.value = updatedField?.value?.replace(/\s/g, '');
    }
    const compareField = {
      ...contactFormData[compareFieldName],
    };
    updatedField.errors.duplicate = null;
    compareField.errors.duplicate = null;
    setInfoTabError(false);

    if (selectedInfoType?.valueType === PDF_fileType) {
      setContactFormData({ [fieldName]: updatedField });
      return true;
    }

    if (contactInfoList?.length > 0) {
      setContactFormData({ [fieldName]: updatedField });
      return true;
    }

    setContactFormData({
      [fieldName]: updatedField,
      [compareFieldName]: compareField,
    });
  };
  const handlePhoneNoChange = (phone) => {
    const currField = { ...contactFormData?.valueField };
    currField.value = phone;
    handleValidation(currField);
    onChangeInformation(currField, 'valueField', 'titleField');
  };

  useEffect(() => {
    if (updateMode?.isEdit) {
      selectRef?.current?.focus();
    }
  }, [updateMode?.isEdit]);

  const resetEdit = () => {
    const infoType = { ...contactFormData?.infoType };
    const valueField = { ...contactFormData?.valueField };
    const titleField = { ...contactFormData?.titleField };
    const displayTitle = { ...contactFormData?.displayTitle };
    // const uploadPdf = { ...contactFormData?.uploadPdf };
    infoType.value = '';
    titleField.value = '';
    valueField.value = '';
    displayTitle.value = '';
    // uploadPdf.value = "";
    setContactFormData({ infoType, titleField, valueField, displayTitle });
    setUpdateMode({ isEdit: false, selectedIndex: -1 });
  };

  const handleInfoAdd = () => {
    const isValid = validate();
    if (!isValid) return false;

    const currInfoList = contactInfoList.map((info) => {
      return { ...info };
    });
    const isPdfType = contactFormData?.infoType?.value === PDF_fileType;

    if (
      !isPdfType &&
      checkDuplicate(
        contactFormData?.titleField?.value?.trim(),
        contactFormData?.valueField?.value,
        'titleField',
      )
    ) {
      const titleField = {
        ...contactFormData.titleField,
        value: contactFormData?.titleField?.value?.trim(),
        errors: { ...contactFormData?.titleField?.errors, duplicate: 'Duplicate Combination' },
      };
      const valueField = {
        ...contactFormData?.valueField,
        errors: { ...contactFormData?.valueField?.errors, duplicate: 'Duplicate Combination' },
      };
      setContactFormData({ titleField, valueField });
      setInfoTabError(true);
      return false;
    }

    const newInfo = {
      type: contactFormData.infoType.value,
      field: isPdfType
        ? contactFormData?.uploadPdf?.value.name || ''
        : contactFormData?.titleField?.value?.trim(),
      value: isPdfType
        ? contactFormData?.uploadPdf?.value?.url || ''
        : contactFormData?.valueField?.value?.trim(),
      displayTitle:
        isPdfType && contactFormData?.uploadPdf?.value?.url
          ? ''
          : contactFormData?.displayTitle?.value?.trim(),
    };

    if (updateMode.isEdit && updateMode.selectedIndex > -1) {
      if (isPdfType) {
        currInfoList[updateMode.selectedIndex].field = contactFormData?.uploadPdf?.value.name || '';
        currInfoList[updateMode.selectedIndex].value = contactFormData?.uploadPdf?.value?.url || '';
        currInfoList[updateMode.selectedIndex].displayTitle =
          contactFormData?.displayTitle?.value?.trim() || '';
      } else {
        currInfoList[updateMode.selectedIndex][infoFieldKey] =
          contactFormData?.titleField?.value?.trim();
        currInfoList[updateMode.selectedIndex][infoValueKey] = contactFormData?.valueField?.value;
        currInfoList[updateMode.selectedIndex].displayTitle =
          contactFormData?.displayTitle?.value?.trim();
      }
      setContactInfoList(currInfoList);
    } else if (isPdfType) {
      currInfoList.push({
        type: contactFormData.infoType.value,
        ...newInfo,
      });
      setContactInfoList(currInfoList);
    } else {
      currInfoList.push({
        type: contactFormData.infoType.value,
        [infoFieldKey]: contactFormData?.titleField?.value?.trim(),
        [infoValueKey]: contactFormData.valueField.value,
        displayTitle: contactFormData?.displayTitle?.value?.trim(),
      });
      setContactInfoList(currInfoList);
    }
    resetEdit();
  };

  const checkDuplicate = (field1Value, field2Value, fldName) => {
    const titleFldValue = fldName === 'titleField' ? field1Value : field2Value;
    const valueFldValue = fldName === 'valueField' ? field1Value : field2Value;

    return contactInfoList?.some((info, infoIndex) => {
      return (
        info[infoFieldKey] === titleFldValue &&
        info[infoValueKey] === valueFldValue &&
        infoIndex !== updateMode?.selectedIndex
      );
    });
  };

  const validate = () => {
    const fieldsToValidate = {};
    if (selectedInfoType?.valueType !== 'PDF') {
      fieldsToValidate.titleField = contactFormData?.titleField;
      fieldsToValidate.valueField = contactFormData?.valueField;
    } else {
      fieldsToValidate.uploadPdf = contactFormData?.uploadPdf;
    }

    const updatedFields = {};
    const isValid = formDataValidate(fieldsToValidate, updatedFields);
    setContactFormData(updatedFields);
    return isValid;
  };

  const onDeleteCustomReviewerInfo = (e, selectedIndex) => {
    e.preventDefault();
    const currInfoList = [...contactInfoList];
    currInfoList.splice(selectedIndex, 1);
    setContactInfoList(currInfoList);
  };

  const reorder = (list, sourctIndex, destinationIndex) => {
    const result = Array.from(list);
    const [removed] = result?.splice(sourctIndex, 1);
    result?.splice(destinationIndex, 0, removed);
    return result;
  };

  const onClickEditReviewerInfo = (e, selectedData, selectedIndex) => {
    e.preventDefault();
    setUpdateMode({ isEdit: true, selectedIndex });
    const infoType = { ...contactFormData?.infoType };
    const valueField = { ...contactFormData?.valueField };
    const titleField = { ...contactFormData?.titleField };
    const displayTitle = { ...contactFormData?.displayTitle };
    const uploadPdf = { ...contactFormData?.uploadPdf };
    titleField.errors = {};
    valueField.errors = {};
    displayTitle.errors = {};
    uploadPdf.errors = {};
    setInfoTabError(false);
    const pdfPopulated = {
      url: selectedData?.value,
      type:
        selectedData?.type === 'PDF' && selectedData?.value?.startsWith('http') ? 'WEB_URL' : 'S3',
      name: selectedData?.field || '',
    };
    infoType.value = selectedData?.type;
    titleField.value = selectedData[infoFieldKey];
    valueField.value = selectedData[infoValueKey];
    valueField.name = selectedData?.name;
    displayTitle.value = selectedData?.displayTitle;
    uploadPdf.value = pdfPopulated;
    updateFieldsForInforType(selectedData?.type, titleField, valueField, displayTitle, uploadPdf);
    setContactFormData({
      infoType,
      titleField,
      valueField,
      displayTitle,
      uploadPdf,
    });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (updateMode?.isEdit) {
      return;
    }
    const items = reorder(contactInfoList, result?.source?.index, result?.destination?.index);
    setContactInfoList(items);
  };

  return (
    <>
      <div className='row'>
        <div className='col-md-6 mb-2'>
          <CustomSelect
            item={contactFormData?.infoType}
            handleInputChange={(e) => onChangeInformationType(e)}
            labelField='text'
            valueField='value'
            options={informationTypes}
            labelPrefix='Select'
            hideNullOption
          />
        </div>
      </div>
      {contactFormData.infoType.value !== '' && (
        <div className='row'>
          {selectedInfoType?.valueType !== PDF_fileType && (
            <>
              <div className='col-md-6 mb-1'>
                <CustomTextField
                  inputRef={selectRef}
                  item={contactFormData?.titleField}
                  handleInputChange={(e) => onChangeInformation(e, 'titleField', 'valueField')}
                  maxLength={36}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
              <div className='col-md-6 mb-1'>
                <CustomTextField
                  item={contactFormData?.displayTitle}
                  handleInputChange={(e) => setContactFormData({ displayTitle: e })}
                  maxLength={36}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </>
          )}
          <div className={isActivityModule ? 'col-md-6 mb-1' : 'col-md-12 mb-1'}>
            {selectedInfoType?.valueType === 'Phone' ? (
              <MuiPhoneNumber
                name='phone'
                label='Phone Number'
                data-cy='user-phone'
                required={true}
                defaultCountry={'in'}
                disableAreaCodes
                autoFormat={true}
                countryCodeEditable={false}
                className='col-md-12'
                value={contactFormData?.valueField?.value}
                error={Boolean(contactFormData?.valueField?.errors?.duplicate) || false}
                helperText={contactFormData?.valueField?.errors?.duplicate}
                onChange={(phone, country) => handlePhoneNoChange(phone)}
                sx={{ '& svg': { height: '1.2rem' } }}
              />
            ) : selectedInfoType?.valueType === PDF_fileType ? (
              <CustomUpload
                item={contactFormData?.uploadPdf}
                hotelId={hotelId}
                showNotification={true}
                additionalInput={{
                  type: ASSET_TYPE_DOC,
                  groupId: groupId,
                  propertyType: ASSET_AMENITIES,
                }}
                onUpload={(e) => {
                  setContactFormData({
                    uploadPdf: e,
                  });
                }}
                webUrlPlaceholder='Paste URL'
                maxFileSize={MAX_PDF_SIZE}
              />
            ) : (
              <CustomTextField
                item={contactFormData?.valueField}
                maxLength={1000}
                handleInputChange={(e) => onChangeInformation(e, 'valueField', 'titleField')}
                multiline={true}
              />
            )}
          </div>
          <div className='col-md-12 mt-1 mb-2'>
            <Button
              variant='outlined'
              color='primary'
              disabled={
                (selectedInfoType?.valueType === PDF_fileType &&
                  !contactFormData?.uploadPdf?.value.url) ||
                (selectedInfoType?.valueType !== PDF_fileType &&
                  (contactFormData?.titleField?.value?.trim()?.length === 0 ||
                    contactFormData?.valueField?.value?.trim()?.length === 0)) ||
                infoTabError ||
                isOnlyCode
              }
              onClick={() => handleInfoAdd()}
              size='small'
              className='me-3 mt-1 mb-1'
            >
              {updateMode?.isEdit ? 'Edit' : 'Add'}{' '}
            </Button>

            {updateMode?.isEdit && (
              <Button
                variant='outlined'
                color='secondary'
                onClick={() => resetEdit()}
                size='small'
                className='me-3 mt-1 mb-1'
              >
                Cancel
              </Button>
            )}
          </div>
        </div>
      )}
      <div className='row mt-2'>
        <div className='col-md-12'>
          <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
            <Droppable droppableId='droppableSpaContactInfo'>
              {(provided, snapshot) => (
                <div
                  {...provided?.droppableProps}
                  className='col-md-12 px-1 py-1 overflow-hidden'
                  ref={provided?.innerRef}
                >
                  {contactInfoList?.map((infoItem, infoIndex) => (
                    <Draggable
                      key={infoIndex}
                      draggableId={`dragId-${infoIndex}`}
                      index={infoIndex}
                      isDragDisabled={updateMode?.isEdit}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={`d-flex justify-content-between custom-info-box ${
                            updateMode?.selectedIndex === infoIndex ? 'edit-mode' : ''
                          }`}
                        >
                          <div className='row w-100 align-items-center'>
                            <div className='col-md-1'>
                              <IconButton aria-label='drag' disabled>
                                <DragIndicatorIcon fontSize='small' className='icon' />
                              </IconButton>
                            </div>
                            <div className='col-md-10 text'>
                              {infoItem?.type === PDF_fileType ? (
                                <div className='row py-2'>
                                  <div className='col-md-12 d-flex align-items-center'>
                                    {infoItem?.field ? (
                                      <>
                                        <PictureAsPdfOutlined className='me-2' />
                                        {infoItem?.field}
                                      </>
                                    ) : (
                                      <div className='col-md-12 text'>
                                        <TextField
                                          value={infoItem?.value}
                                          InputProps={{ readOnly: true }}
                                          className='info-field-edit'
                                          fullWidth
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className='col-md-10 text'>
                                  <div className='row py-2'>
                                    <div className='col-md-6 text'>
                                      <TextField
                                        value={infoItem?.[infoFieldKey]}
                                        InputProps={{ readOnly: true }}
                                        className='info-field-edit'
                                        fullWidth
                                      />
                                    </div>

                                    <div className='col-md-6 text'>
                                      <TextField
                                        value={infoItem?.displayTitle}
                                        InputProps={{ readOnly: true }}
                                        className='info-field-edit'
                                        fullWidth
                                      />
                                    </div>

                                    <div
                                      className={
                                        isActivityModule ? 'col-md-6 text' : 'col-md-12 text'
                                      }
                                    >
                                      {isActivityModule && infoItem?.type === 'PHONE' ? (
                                        <MuiPhoneNumber
                                          value={infoItem.value}
                                          defaultCountry={'in'}
                                          countryCodeEditable={false}
                                          autoFormat
                                          fullWidth
                                          className='info-field-edit'
                                          sx={{ '& svg': { height: '1.2rem' } }}
                                        />
                                      ) : (
                                        <TextField
                                          value={infoItem?.URL || infoItem.value || infoItem.url}
                                          InputProps={{ readOnly: true }}
                                          className='info-field-edit'
                                          fullWidth
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='d-flex'>
                            <IconButton
                              aria-label='edit'
                              disabled={updateMode?.isEdit}
                              onClick={(e) => onClickEditReviewerInfo(e, infoItem, infoIndex)}
                            >
                              <EditIcon fontSize='small' />
                            </IconButton>

                            <IconButton
                              aria-label='delete'
                              onClick={(e) => onDeleteCustomReviewerInfo(e, infoIndex)}
                            >
                              <RemoveCircleIcon fontSize='small' />
                            </IconButton>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </>
  );
};

export default ContactInformation;
